<div class="white-rounded-container width-100vw">
    <div class="table-button-container">
        <button mat-icon-button color="primary" aria-label="collapse" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    <app-prime-ng-array-d4 arrayName="factures" nullArrayDisplayText="Aucune commande" columnResizeMode="fit"
        [columnsDefinition]="columnsDefinition" [objectList]="invoices" [heightMode]="'full'" [loading]="loading"
        (editionOutputV2)="rowAction($event)">
    </app-prime-ng-array-d4>
</div>